import ApiService from "@/common/api/api.service";

export const PersonService = {

    list() {
        ApiService.setHeader()
        return ApiService.get('persons')
    },
    get(slug) {
        ApiService.setHeader()
        return ApiService.get('persons', slug)
    },
    search(page=1, itemsPerPage=10, active=true, search="", orderBy = "", sortDesc = "") {
        ApiService.setHeader()
        return ApiService.get(`persons?page=${page}&itemsPerPage=${itemsPerPage}&active=${active}&search=${search}&orderBy=${orderBy}&sortDesc=${sortDesc}`)
    },
    searchByName(slug) {
        ApiService.setHeader()
        return ApiService.get('persons/search', slug)
    },
    update(slug, data) {
        ApiService.setHeader()
        return ApiService.update('persons', slug, data)
    },
    post(slug, data) {
        ApiService.setHeader()
        return ApiService.post('persons', data)
    },

    // get_logo(){
    //     ApiService.setHeader()
    //     return ApiService.getImageBlob('profile/logo')
    // },
    // save_logo(file){
    //     ApiService.setHeader()
    //     let formData = new FormData();
    //     formData.append("file", file);
    //     return ApiService.postFile('profile/logo', formData)
    // }

 
}